var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgregar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.6 16.944C8.19467 16.944 7.88533 16.8373 7.672 16.624C7.48 16.3893 7.384 16.08 7.384 15.696V10H1.784C1.4 10 1.10133 9.904 0.888 9.712C0.674667 9.49867 0.568 9.2 0.568 8.816C0.568 8.432 0.674667 8.144 0.888 7.952C1.10133 7.73867 1.4 7.632 1.784 7.632H7.384V2.096C7.384 1.712 7.48 1.41333 7.672 1.2C7.88533 0.986666 8.20533 0.879999 8.632 0.879999C9.016 0.879999 9.304 0.986666 9.496 1.2C9.70933 1.41333 9.816 1.712 9.816 2.096V7.632H15.416C15.8213 7.632 16.12 7.73867 16.312 7.952C16.5253 8.144 16.632 8.432 16.632 8.816C16.632 9.2 16.5253 9.49867 16.312 9.712C16.12 9.904 15.8213 10 15.416 10H9.816V15.696C9.816 16.08 9.70933 16.3893 9.496 16.624C9.304 16.8373 9.00533 16.944 8.6 16.944Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgregar);
export default __webpack_public_path__ + "static/media/agregar.9580cedd62e6b2d1454964074f9af207.svg";
export { ForwardRef as ReactComponent };